export default __webpack_public_path__ + "static/media/webApp.036f7481.png";